import {
    SHARED_API_URL,
    WGEN_HELP_URL,
    HELP_PARAMS,
    URL as SHARED_URL,
    PARAM as SHARED_PARAM,
    ASSESSMENT as SHARED_ASSESSMENT,
    DIBELS_SEVEN_STUDENT_SUMMARY,
} from '../shared/ApiConstants';
import { LICENSE } from './CommonConstants';

const { TEXAS, TRC, LOUISIANA } = LICENSE;

const APP_ROOT_URL = '/reading-classroom-reports';
const TRO_BASE_URL = '/tro_results_api';
const TRO_CONTENT_BASE_URL = '/tro_content_api';
const DECODING_RESULT_BASE_URL = '/lantern-decoding-api/results/v1';
const DECODING_CONTENT_BASE_URL = '/lantern-decoding-api/content/v1';
const DECODE_RESULT_BASE_URL = '/decode-api/results/v1';
const DECODE_CONTENT_BASE_URL = '/decode-api/content/v1';
const RAN_BASE_URL = '/lanternran/v01';
const BURST_BASE_URL = '/joule-results-api/burst';
const INTERVENTION_BASE_URL = '/joule-results-api/intervention';
const MAZE_URL = '/maze-api/v1';
const PORTAL_URL = '/portal';
const D8_BASE_URL = '/dnext';
const SHARED_API_OBJECT = SHARED_API_URL(D8_BASE_URL, APP_ROOT_URL);

export const INTERVENTION_GROUP_URL = '/intervention/manage_groups';

export const AT_RISK = 'At Risk';
export const BLOB_RESPONSE_TYPE = 'blob';

export const { BASE_URLS, SS_URL } = SHARED_API_OBJECT;
const { BASE_URL } = BASE_URLS;

export const ASSESSMENT = {
    ...SHARED_ASSESSMENT,
    R3D: 'r3dmod',
};

export const AUDIO_HEADERS = {
    Accept: 'audio/wav',
};

export const ALL_BOOKS_TRO_HEADERS = {
    'x-get-all-books': true,
};

export const RESCORING_OPERATIONS = {
    RESCORE: 'rescore',
    REVERT: 'revert',
};

export const DECODING_NEEDED_FIELDS = [
    'form_id',
    'questions',
    'period',
    'correct_responses',
    'grade_level',
    'measure',
];

export const URL = {
    ...SHARED_URL,
    TRO: {
        TRO_RESULTS: `${TRO_BASE_URL}/results`,
        TRO_BOOKS: `${TRO_CONTENT_BASE_URL}/books`,
        TRO_HELP_URL: `${WGEN_HELP_URL}/mcxp${HELP_PARAMS}`,
    },
    EXPRESS: {
        EXPRESS_HELP_URL: `${WGEN_HELP_URL}/mcxp${HELP_PARAMS}`,
    },
    DECODING: {
        DECODING_RESULTS: `${DECODING_RESULT_BASE_URL}/results`,
        DECODING_HELP_URL: `${WGEN_HELP_URL}/mcxp${HELP_PARAMS}`,
        DECODING_INTERPS: `${DECODING_CONTENT_BASE_URL}/interpretations`,
        DECODING_FORM: `${DECODING_CONTENT_BASE_URL}/forms`,
        DECODING_OBSERVATIONS: `${DECODING_CONTENT_BASE_URL}/observations`,
    },
    DECODE: {
        DECODE_RESULTS: `${DECODE_RESULT_BASE_URL}/results`,
        DECODE_FORM: `${DECODE_CONTENT_BASE_URL}/forms`,
    },
    RAN: {
        RAN_RESULTS: `${RAN_BASE_URL}/results?`,
        RAN_INTERPS: `${RAN_BASE_URL}/interpretations`,
        RAN_FORM: `${RAN_BASE_URL}/forms`,
        RAN_HELP_URL: `${WGEN_HELP_URL}/ran2${HELP_PARAMS}RAN_`,
    },
    BURST: {
        BURST_STUDENTS_ENROLLMENT_INFO: `${BURST_BASE_URL}/v1/burst_group_students`,
        BURST_STUDENTS_DATA: `${BURST_BASE_URL}/v1/student_data`,
        BURST_PROBE_DETAILS: `/burstAssessment/probeDetails`,
    },
    INTERVENTION: {
        INTERVENTION_STUDENTS_ENROLLMENT_INFO: `${INTERVENTION_BASE_URL}/v1/intervention_group_students`,
        INTERVENTION_STUDENTS_DATA: `${INTERVENTION_BASE_URL}/v1/student_data`,
    },
    MAZE: {
        MAZE_FORMS: `${MAZE_URL}/forms`,
        MAZE_INTERPS: `${MAZE_URL}/cutscores`,
        MAZE_DELETE_RESULT: `${MAZE_URL}/results`,
        MAZE_CREATE_RESULT: `${MAZE_URL}/web_entry_result`,
    },
    HELP: {
        DIBELS8_WITHOUT_TRC_HELP: `${WGEN_HELP_URL}/md8e${HELP_PARAMS}`,
        DIBELS8_WITHOUT_TRC_TEXAS_HELP: `${WGEN_HELP_URL}/mtxd8e${HELP_PARAMS}`,
        DIBELS8_WITHOUT_TRC_LOUISIANA_HELP: `${WGEN_HELP_URL}/mlad8e${HELP_PARAMS}`,
        DIBELS8_WITH_TRC_HELP: `${WGEN_HELP_URL}/md8ent${HELP_PARAMS}`,
        DIBELS8_WITH_TRC_TEXAS_HELP: `${WGEN_HELP_URL}/mtxd8ent${HELP_PARAMS}`,
        DIBELS8_WITH_TRC_LOUISIANA_HELP: `${WGEN_HELP_URL}/mlad8e${HELP_PARAMS}`,
        DIBELS8_WITH_TRO_HELP: `${WGEN_HELP_URL}/md8etro${HELP_PARAMS}`,
        OL_PROBE_DETAILS_HELP: `${WGEN_HELP_URL}/md8ent${HELP_PARAMS}`,
    },
    USER_PROFILE_URL: `${PORTAL_URL}/userprofile`,
    DIBELS_SEVEN_STUDENT_SUMMARY_URL: `${BASE_URL}/${DIBELS_SEVEN_STUDENT_SUMMARY}`,
    STUDENT_GOALS_URL: '/dibels8-api/zones-of-growth/student_goals',
    D8_FORM_URL: '/dibels8-api/content/v1/forms',
    D8_INTERPS_URL: '/dibels8-api/content/v1/cutscores',
    D8_RESULT_URL: '/dibels8-api/results/v1/results',
    D8_INVALIDATE_RESULTS_URL: '/dibels8-api/results/v1/invalidate-results',
    D8_COMPOSITE_INTERPS_URL: '/dibels8-composites/v1/composite_cutscores',
    D8_OBSERVATIONS_URL: '/dibels8-api/content/v1/observations',
    D8_INSTRUCTION_PM_URL: '/dibels8-api/instruction-pm/v1/dates',
    ONLINE_HELP: `${WGEN_HELP_URL}/mcxp${HELP_PARAMS}D_TRO_R`,
};

export const PARAM = {
    ...SHARED_PARAM,
    BURST_GROUP_ID: 'group_uid',
    BURST_SCHOOL_UID: 'school_uid',
    BOOK_ID: 'book_id',
    BURST_DISTRICT_UID: 'district_uid',
    BURST_SEMESTER: 'semester',
    BURST_GROUP_UID: 'burstGroupUid',
    OPERATION: 'operation',
    DECODING_WITHOUT_AUDIO: 'with_raw_form',
    WITH_LEXILES: 'with_lexiles',
    DECODING_NEEDED_FIELDS: 'fields',
    WITH_ALL_RESULTS: 'with_all_results',
};
export const getD8WithAndWithoutTRCHelp = licensingInfo => {
    const getTexasLouisianaLicence =
        licensingInfo
            .filter(item => [TEXAS, LOUISIANA].includes(item))
            ?.map(item => `_${item}`)[0] || '';

    const getD8WithoutTrcHelp = URL.HELP[`DIBELS8_WITHOUT_TRC${getTexasLouisianaLicence}_HELP`];
    const getD8WithTrcHelp = URL.HELP[`DIBELS8_WITH_TRC${getTexasLouisianaLicence}_HELP`];

    return { getD8WithoutTrcHelp, getD8WithTrcHelp };
};

export const getMainHelpUrl = licensingInfo => {
    const withTrcBaseUrl = licensingInfo.includes(TRC);
    const { getD8WithoutTrcHelp, getD8WithTrcHelp } = getD8WithAndWithoutTRCHelp(licensingInfo);
    return withTrcBaseUrl ? getD8WithTrcHelp : getD8WithoutTrcHelp;
};
